import {
  Dimension__toString_impl_o4q1adx82fzjdnbyok as Dimension__toString_impl_o4q1ad,
  Dimension__hashCode_impl_p583vw27ml4nzz2xkra as Dimension__hashCode_impl_p583vw,
} from './data.mjs';
import {
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ConstantClass;
function Constant() {
  if (ConstantClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.ray_1 = value;
      }
      toString() {
        return 'Constant(value=' + Dimension__toString_impl_o4q1ad(this.ray_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.ray_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Constant()))
          return false;
        if (!equals(this.ray_1, other.ray_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Constant');
    ConstantClass = $;
  }
  return ConstantClass;
}
var RatioOfSpacingClass;
function RatioOfSpacing() {
  if (RatioOfSpacingClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.oay_1 = value;
      }
      toString() {
        return 'RatioOfSpacing(value=' + this.oay_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.oay_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RatioOfSpacing()))
          return false;
        if (!equals(this.oay_1, other.oay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RatioOfSpacing');
    RatioOfSpacingClass = $;
  }
  return RatioOfSpacingClass;
}
var ForceConstantClass;
function ForceConstant() {
  if (ForceConstantClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value) {
        super();
        this.qay_1 = value;
      }
      toString() {
        return 'ForceConstant(value=' + Dimension__toString_impl_o4q1ad(this.qay_1) + ')';
      }
      hashCode() {
        return Dimension__hashCode_impl_p583vw(this.qay_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ForceConstant()))
          return false;
        if (!equals(this.qay_1, other.qay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ForceConstant');
    ForceConstantClass = $;
  }
  return ForceConstantClass;
}
var RatioOfSizeClass;
function RatioOfSize() {
  if (RatioOfSizeClass === VOID) {
    class $ extends CornerRadii() {
      constructor(ratio) {
        ratio = ratio === VOID ? 0.5 : ratio;
        super();
        this.pay_1 = ratio;
      }
      toString() {
        return 'RatioOfSize(ratio=' + this.pay_1 + ')';
      }
      hashCode() {
        return getNumberHashCode(this.pay_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof RatioOfSize()))
          return false;
        if (!equals(this.pay_1, other.pay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'RatioOfSize', RatioOfSize);
    RatioOfSizeClass = $;
  }
  return RatioOfSizeClass;
}
var PerCornerClass;
function PerCorner() {
  if (PerCornerClass === VOID) {
    class $ extends CornerRadii() {
      constructor(value, topLeft, topRight, bottomLeft, bottomRight) {
        topLeft = topLeft === VOID ? false : topLeft;
        topRight = topRight === VOID ? false : topRight;
        bottomLeft = bottomLeft === VOID ? false : bottomLeft;
        bottomRight = bottomRight === VOID ? false : bottomRight;
        super();
        this.jay_1 = value;
        this.kay_1 = topLeft;
        this.lay_1 = topRight;
        this.may_1 = bottomLeft;
        this.nay_1 = bottomRight;
      }
      toString() {
        return 'PerCorner(value=' + Dimension__toString_impl_o4q1ad(this.jay_1) + ', topLeft=' + this.kay_1 + ', topRight=' + this.lay_1 + ', bottomLeft=' + this.may_1 + ', bottomRight=' + this.nay_1 + ')';
      }
      hashCode() {
        var result = Dimension__hashCode_impl_p583vw(this.jay_1);
        result = imul(result, 31) + getBooleanHashCode(this.kay_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.lay_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.may_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.nay_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PerCorner()))
          return false;
        if (!equals(this.jay_1, other.jay_1))
          return false;
        if (!(this.kay_1 === other.kay_1))
          return false;
        if (!(this.lay_1 === other.lay_1))
          return false;
        if (!(this.may_1 === other.may_1))
          return false;
        if (!(this.nay_1 === other.nay_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PerCorner');
    PerCornerClass = $;
  }
  return PerCornerClass;
}
var CornerRadiiClass;
function CornerRadii() {
  if (CornerRadiiClass === VOID) {
    class $ {}
    initMetadataForClass($, 'CornerRadii');
    CornerRadiiClass = $;
  }
  return CornerRadiiClass;
}
//region block: exports
export {
  Constant as Constant5dc3leeorpdb,
  ForceConstant as ForceConstant11m1vt5jr2l8f,
  PerCorner as PerCorner27xb33zgvi5gv,
  RatioOfSize as RatioOfSize1ip5bd7oxn8ba,
  RatioOfSpacing as RatioOfSpacing2du8cst35dyuc,
};
//endregion

//# sourceMappingURL=CornerRadii.mjs.map
